import { subscribeToConsent } from '../utils/consent/consentGate'
import { reportConsentState } from '../utils/consent/reportConsentState'

export default defineNuxtPlugin({
  name: 'consent-state',
  setup: () => {
    subscribeToConsent(reportConsentState)
  },
})
